import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "d-flex justify-end" }

export function render(_ctx, _cache) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_textarea = _resolveComponent("v-textarea")
  const _component_BaseButton = _resolveComponent("BaseButton")
  const _component_v_form = _resolveComponent("v-form")

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading && _ctx.showSkeleton)
      ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
          key: 0,
          type: "article, actions"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.nextDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Delay time set", -1)),
                  _createElementVNode("div", _hoisted_3, " Case title: " + _toDisplayString(_ctx.caseModel ? _ctx.caseModel.title : ""), 1)
                ]),
                _cache[3] || (_cache[3] = _createTextVNode(" Thank you for your feedback. ", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" Please provide feedback until " + _toDisplayString(_ctx.nextDate) + " CET. ", 1),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                _cache[7] || (_cache[7] = _createTextVNode(" If you do not provide feedback until the chosen date, the case will be escalated. ", -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[8] || (_cache[8] = _createElementVNode("h1", null, "Set delay time for the case", -1)),
                  _createElementVNode("div", _hoisted_6, " Case title: " + _toDisplayString(_ctx.caseModel ? _ctx.caseModel.title : ""), 1)
                ]),
                _createVNode(_component_v_form, {
                  ref: "form",
                  onSubmit: _withModifiers(_ctx.submit, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block mb-1" }, " Please enter the estimated delay (days) for this case here: ", -1)),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.days,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.days) = $event)),
                        label: "Days",
                        type: "number",
                        style: {"width":"200px"},
                        rules: [(v) => !!v || 'Days is required'],
                        variant: "outlined",
                        loading: _ctx.loading,
                        clearable: ""
                      }, null, 8, ["modelValue", "rules", "loading"])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block mb-1" }, " Please provide us with the reason why the case needs to be delayed for more than 5 working days: ", -1)),
                      _createVNode(_component_v_textarea, {
                        variant: "outlined",
                        label: "Reason",
                        rules: [(v) => !!v || 'Reason is required'],
                        loading: _ctx.loading,
                        modelValue: _ctx.reason,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.reason) = $event))
                      }, null, 8, ["rules", "loading", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_BaseButton, {
                        submit: "",
                        width: 200,
                        disabled: _ctx.loading || _ctx.disabled
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode(" Confirm ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ]))
        ], 64))
  ]))
}